/* eslint-disable object-property-newline */
import PropTypes from "prop-types";

const MetaItem = ({ Icon, className, label }) => (
	<div className={`meta-item d-flex align-items-center ${className}`}>
		{<Icon className="text-blue me-2" style={{ minWidth: "24px", width: "24px" }} />}

		<span className="text-neutral3">
			{label}
		</span>
	</div>
);

MetaItem.propTypes = {
	Icon: PropTypes.func.isRequired,
	className: PropTypes.string,
	label: PropTypes.string.isRequired
};

MetaItem.defaultProps = {
	className: "mb-2"
};

export default MetaItem;
